import { render, staticRenderFns } from "./ClosureHome.vue?vue&type=template&id=d4a48a06"
import script from "./ClosureHome.vue?vue&type=script&lang=js"
export * from "./ClosureHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports